import React, { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { gameProgressState } from '../state';
import { GAME_OBJECT_IMAGES } from './common/images'

const Home = () => {
  useEffect(() => {
    console.log('preload images');
    GAME_OBJECT_IMAGES.forEach((imgSrc) => {
      const img = new Image();
      img.src = imgSrc;
      window[imgSrc] = img;
    });
  }, []);

  useEffect(() => {
    const hasMouseCheck = () => {
        document.getElementById('audio').play();
        // Kill the event listener, so it executes only once
        window.removeEventListener('click', hasMouseCheck);
    };
    window.addEventListener('click', hasMouseCheck, false);
  }, [])

  const setGameProgress = useSetRecoilState(gameProgressState);
  return (
    <div>
      <div className="start-frame">
        <div className="start-title">
          <img src="img/Leopard-cat-LOGO.png" className="start-titleimg" alt='start-title' />
          <br />
          <img src="img/Leopard-cat-home.png" className="start-tlimg" alt='background' />
          <br />
          <button onClick={() => setGameProgress('intro')} className="start-botton">START / 開始</button>
        </div>
      </div>

      <div className="start-alert">建議使用Internet Explorer以外的瀏覽器，以達到最佳瀏覽效果。</div>
    </div>
  );
};

export {
  Home
};
